import localStorageMixin from "@/components/mixins/localStorageMixin";
import {mapState} from "vuex";

function setProfileInGalleryDataToLocalStorage(galleryData) {
    this.setGalleryIdToProfileRedirectToLocalStorage(galleryData.id, galleryData.all);
    this.setLocalStorageObject(this.galleryDataKey, galleryData, this.moment().add(5, 'minutes').toISOString());
}

function setGalleryIdToProfileRedirectToLocalStorage(galleryId, isAll = null) {
    this.setLocalStorageObject(this.redirectToGalleryKey, {id: galleryId, all: isAll}, this.moment().add(30, 'minutes').toISOString());
}

function pullProfileGalleryForRedirectFromLocalStorage() {
    const gallery = this.getLocalStorageObject(this.redirectToGalleryKey);
    this.deleteLocalStorageItem(this.redirectToGalleryKey);
    return gallery;
}

function pullProfileGalleryDataFromLocalStorage() {
    const data = this.getLocalStorageObject(this.galleryDataKey);
    this.deleteLocalStorageItem(this.galleryDataKey);
    return data;
}

export default {
    data() {
        return {
            redirectToGalleryKey: 'redirectToGallery',
            galleryDataKey: 'galleryData',
            moment: moment,
        }
    },
    methods: {
        setGalleryIdToProfileRedirectToLocalStorage,
        pullProfileGalleryForRedirectFromLocalStorage,
        setProfileInGalleryDataToLocalStorage,
        pullProfileGalleryDataFromLocalStorage,
    },
    mixins: [localStorageMixin],
    computed: {
        ...mapState(['regionData']),
    }
}
